import {
  Kamoku,
  HasId,
  TaishakuTaishoKmkTypeType,
  OutputFundTypeType,
  ResponseSettingItem,
  TaishakuTaishoElementTypeType,
  TaishakuTaishoCategoryTypeType,
  TaishakuTaishoSubcategoryTypeType,
  taishakuTaishoKmkTypeType,
  taishakuTaishoElementTypeType,
  taishakuTaishoCategoryTypeType, taishakuTaishoSubcategoryTypeType
} from '@/repositories/keiei-joho/data'
import { CorporationTypeType } from '@/views/corporation-info/types'

export type ResponseTaishakuTaishoSettingItem = HasId & {
  kmkName: string;
  kmkType: TaishakuTaishoKmkTypeType;
  elementType: TaishakuTaishoElementTypeType;
  isRequiredSettingType1: boolean;
  isRequiredSettingType2To5: boolean;
  positiveKmkSettings: ResponseSettingItem;
  negativeKmkSettings: ResponseSettingItem;
}

export type ResponseTaishakuTaishoSetting = {
  kamokuSources: Kamoku[],
  items: ResponseTaishakuTaishoSettingItem[],
  outputFundType: OutputFundTypeType,
  corporationType: CorporationTypeType
}

export type CorporationInfo = {
  corporationName: string,
  location: string,
  medicalCorporationNumber: string,
  corporationType: CorporationTypeType,
}

export interface HasKin {
  kin: number | null;
}

export type TaishakuTaishoKmkType = HasKin & {
  kmkName: string;
  kmkType: TaishakuTaishoKmkTypeType;
  elementType: TaishakuTaishoElementTypeType;
  categoryType: TaishakuTaishoCategoryTypeType;
  subcategoryType: TaishakuTaishoSubcategoryTypeType;
  isAggregate: boolean;
  isRequiredSettingType1: boolean;
  isRequiredSettingType2To5: boolean;
  exportKmkName: string;
}
export function initializeTaishakuTaishoKmk (): TaishakuTaishoKmkType {
  return {
    kmkName: '',
    kmkType: taishakuTaishoKmkTypeType.RyudoShisan,
    elementType: taishakuTaishoElementTypeType.Shisan,
    categoryType: taishakuTaishoCategoryTypeType.RyudoShisan,
    subcategoryType: taishakuTaishoSubcategoryTypeType.YukeiKoteiShisan,
    isAggregate: false,
    isRequiredSettingType1: false,
    isRequiredSettingType2To5: false,
    exportKmkName: '',
    kin: null
  }
}

export type ResponseTaishakuTaishoExportLayout = {
  corporationInfo: CorporationInfo,
  kmkTypes: TaishakuTaishoKmkType[],
  outputFundType: OutputFundTypeType
}
